import React, { useState } from "react";
import { Box, TextField, Button, Typography, Alert } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../api";

const ResetSenha = () => {
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [sucesso, setSucesso] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const handleResetSenha = async () => {
    if (!novaSenha || !confirmarSenha) {
      setMensagem("Por favor, preencha todos os campos.");
      return;
    }

    if (novaSenha !== confirmarSenha) {
      setMensagem("As senhas não coincidem.");
      return;
    }

    try {
      await api.post("/auth/reset-senha", { token, novaSenha });
      setMensagem("Senha redefinida com sucesso.");
      setSucesso(true);
    } catch (error) {
      setMensagem(
        error.response?.data?.message ||
          "Erro ao redefinir a senha. Tente novamente."
      );
      setSucesso(false);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: { xs: 300, sm: 400 },
        margin: "0 auto",
        padding: { xs: 2, sm: 4 },
        textAlign: "center",
        backgroundColor: "#f9f9f9",
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <Typography variant="h4" component="h1" mb={2}>
        Redefinir Senha
      </Typography>
      {mensagem && (
        <Alert severity={sucesso ? "success" : "error"} sx={{ mb: 3 }}>
          {mensagem}
        </Alert>
      )}
      {!sucesso ? (
        <>
          <TextField
            label="Nova Senha"
            type="password"
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Confirmar Senha"
            type="password"
            value={confirmarSenha}
            onChange={(e) => setConfirmarSenha(e.target.value)}
            fullWidth
            margin="normal"
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleResetSenha}
            fullWidth
            sx={{ mt: 2 }}
          >
            Redefinir Senha
          </Button>
        </>
      ) : (
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/login")}
          fullWidth
          sx={{ mt: 2 }}
        >
          Voltar para Login
        </Button>
      )}
    </Box>
  );
};

export default ResetSenha;
